import { ValidationStatus } from '../../../../../../../views/marketing/followers/import';

export default {
  status: {
    [ValidationStatus.Valid]: {
      title: 'A sua importação está quase pronta!',
      description: 'Clique no botão prosseguir para concluir a importação',
    },
    [ValidationStatus.HasInvalidContent]: {
      title: 'Alguns dados no seu ficheiro estão em falta ou têm formato incorreto',
      description:
        'Por favor, corrija os erros abaixo e recarregue o ficheiro ou prossiga para ignorar linhas/células inválidas',
    },
    [ValidationStatus.Invalid]: {
      title: 'O ficheiro carregado não pode ser processado',
      description: 'Por favor, corrija os erros abaixo e tente novamente',
    },
  },
  sections: {
    heading_validation: {
      title: 'Detetada incompatibilidade no nome/ordem das colunas:',
      rules: {
        Exact: 'A coluna #{{column}} deve existir e ter exatamente o nome <strong>{{expected}}</strong>',
      },
    },
    content_validation: {
      title: 'Foram detetados os seguintes erros:',
      labels: {
        row: 'Linha <strong>#{{row}}:</strong>',
        imported_rows_one: '{{count}} linha será importada',
        imported_rows_other: '{{count}} linhas serão importadas',
        ignored_rows_one: '{{count}} linha será ignorada',
        ignored_rows_other: '{{count}} linhas serão ignoradas',
      },
      fields: {
        email: 'Email',
        phone_number: 'Número de telefone',
        first_name: 'Nome próprio',
        last_name: 'Apelido',
        birthday: 'Aniversário',
      },
      rules: {
        Required: 'O campo {{field}} é obrigatório. A linha será ignorada',
        Email: 'O campo {{field}} deve ser um endereço de email válido. A linha será ignorada',
        Phone: 'O campo {{field}} deve ser um número de telefone em formato internacional. O campo será ignorado',
        Date: 'O campo {{field}} deve ser uma data válida. O campo será ignorado',
      },
    },
  },
  buttons: {
    back_to_upload: 'Voltar ao carregamento',
    proceed: 'Prosseguir',
  },
  toasts: {
    error: 'Algo correu mal, por favor contacte o suporte',
  },
};
